<template>
  <StoryblokComponent v-for="blokBody in blok.blocks" :key="blokBody._uid" :blok="blokBody" />
</template>
<script setup>
const { formatBreadcrumbs } = useHrMeta()
const props = defineProps({ blok: Object })
const hero = props.blok.blocks?.find(blok => blok.component === 'SbHero')
let image = null
if (hero) {
  image = hero.background?.find(blok => blok.component === 'SbImage')
}

formatBreadcrumbs()

useHead({
  title: props.blok?.title,
  meta: [
    props.blok?.description ? { name: 'description', content: props.blok?.description } : null,
    props.blok?.title
      ? {
          key: 'og:title',
          property: 'og:title',
          content: `${props.blok?.title} - Hengelose Revue`
        }
      : null,
    props.blok?.description
      ? {
          key: 'og:description',
          property: 'og:description',
          content: props.blok?.description
        }
      : null,

    image
      ? {
          key: 'og:image',
          property: 'og:image',
          content: image.image.filename
        }
      : null
  ]
})
</script>
